import React, { Component } from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

class AnalysisView extends Component {
  state = {};
  render() {
    const { open, onClose, selectedAlloy, rows } = this.props;
    return (
      <div>
        <Dialog open={open} onClose={onClose}>
          <DialogTitle>جدول آنالیز {selectedAlloy}</DialogTitle>
          <DialogContent>
            <TableContainer>
              <Table aria-label="جدول آنالیز">
                <TableHead>
                  <TableRow>
                    <TableCell>عنصر</TableCell>
                    <TableCell align="right">Min</TableCell>
                    <TableCell align="right">Max</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <TableRow
                      key={row.element}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {row.element}
                      </TableCell>
                      <TableCell align="right">{row.min_value}</TableCell>
                      <TableCell align="right">{row.max_value}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default AnalysisView;
